/** Public invitation contract. This entrypoint has no private API workspace dependency. */
import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
export const INVITATION_PERMISSION_KEYS = [
    "canAccessAccountAliasesAndSubAccounts",
    "canAccessBilling",
    "canAccessBookkeepingReports",
    "canAccessConnectedUsers",
    "canAccessContractors",
    "canAccessDocuments",
    "canAccessLinkedAccounts",
    "canAccessProjectManagement",
    "canAccessQuarterlyEstimates",
    "canAccessTaxOrganizer",
    "canAccessTransactionsTable",
];
export function createInvitationClient(config) {
    return createORPCClient(new RPCLink({
        url: `${config.baseUrl.replace(/\/$/, "")}/api/v1`,
        fetch: (request, init) => (config.fetchFn ?? fetch)(request, {
            ...init,
            credentials: "include",
            cache: "no-store",
            referrerPolicy: "no-referrer",
        }),
    }));
}
